import axios from './axiosInstances/axiosInstance';

export const getRestaurantByRef = (storeCode) => {
  return axios.get(`/restaurants/byref/${storeCode}`);
};
